<template>
  <el-dialog title="选择馆藏封面" :visible.sync="centerDialogVisible" width="860px" center>
    <div class="form">
      <div v-for="(item,index) in listItem" :key="index" class="image" @click="selectImage(index)">
        <el-image style="width: 100%;height: 100%;" :src="item" fit="contain" :lazy="true" />
        <div v-if="index == checkIndex" class="check">
          <img src="@/assets/select.png" alt="404">
        </div>
      </div>

    </div>
    <el-divider direction="horizontal" />
    <div class="bottom">
      <el-button class="btn-check" @click="onsubmit">保存</el-button>
      <el-button style="margin-left:20px" class="btn-off" @click="centerDialogVisible = false">取消</el-button>
    </div>

  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      centerDialogVisible: false,
      listItem: [],
      optionsList: [],
      indexItem: 0,
      checkIndex: -1,
      form: {
        teamType: ''
      }
    }
  },
  mounted() {

  },
  methods: {
    // isOpen(index) {
    //   console.log(index)
    //   this.indexItem = index
    //   this.centerDialogVisible = true
    // },
    isOpen(index, allurl) {
      this.listItem = allurl
      this.indexItem = index
      this.centerDialogVisible = true
    },
    onsubmit() {
      this.centerDialogVisible = false
      if (this.checkIndex === -1) {
        return
      }

      this.$emit('changeImage', {
        indexItem: this.indexItem,
        image: this.listItem[this.checkIndex]
      })
    },
    selectImage(index) {
      this.checkIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  overflow: auto;

  .image {
    width: 190px;
    margin: 10px;
    cursor: pointer;
    overflow: hidden;
    height: 128px;
    position: relative;
  }

  .check {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background: #4C70E8;

  }
}

.btn-check {
  width: 100px;
  height: 30px;
  background: #4C70E8;
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
  border-radius: 5px;
  padding: 0px;
}

.btn-off {
  width: 100px;
  height: 30px;
  background: #7B84A1;
  opacity: 0.5;
  border-radius: 5px;
  font-size: 14px;
  color: #ffffff;
  font-weight: bold;
  padding: 0px;
}

 .bottom {
  padding: 18px 20px 18px;
  display: flex;
  justify-content: center;

}

::v-deep .el-textarea__inner {
  padding: 5px 10px;
  resize: none;
  height: 30px !important;
  border-radius: 0px;
  font-size: 12px;
  background-color: #F9F9FC;
  border: 1px solid #DEE0E7 !important;
}

::v-deep .el-dialog__body {
  padding: 0px 10px 20px 10px;

}

::v-deep .el-dialog__header {
  padding: 15px 20px;
}

::v-deep .el-dialog__title {
  height: 20px;
  font-size: 20px;

  font-weight: bold;
  color: #4C70E8;

}

::v-deep .el-divider--horizontal {

  margin: 20px 0;
}
</style>
